import type { StaticEntityType } from "@config";
import "../styles/index.scss";

export const PdfEntireSlideImageLibrary = ({
  entity,
}: {
  entity: StaticEntityType;
}) => {
  const { settings } = entity;

  const { index, url } = settings.imageData;
  return (
    <div className="pdf-entire-slide-img-tAofoADcig2w7F06 tw-h-full tw-w-full">
      <img
        src={url}
        alt={`pdf page: ${index + 1}`}
        className="tw-h-full tw-w-full"
      />
    </div>
  );
};
